import AccessAlarmOutlinedIcon from "@mui/icons-material/AccessAlarmOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { Box, Button, Dialog, Divider, Grid, IconButton, Typography } from "@mui/material";
// import { deleteEvent } from "api/services/events";
import { useConfirm } from "context/ConfirmDialog";
import { snack } from "components/toast";
import moment from "moment";
import { useState } from "react";
import { useMutation, useQueryClient } from "react-query";
import { getTitle } from "utils";
// import EditEvent from "./EditEvent";
import CloseIcon from "@mui/icons-material/Close";
import ValidateAccess from "components/ValidateAccess";
import { Permissions } from "data/permissons";

const ViewEvent = ({ open, setOpen, data, from = "calendar" }) => {
  const queryClient = useQueryClient();
  const [editOpen, setEditOpen] = useState(false);
  const confirm = useConfirm();

  const EditEventClicked = () => {
    setEditOpen(true);
    setOpen(false);
  };

  // let { mutate } = useMutation(deleteEvent, {
  //   onSuccess: () => {
  //     if(data?.task){
  //       snack.success("Task Event Deleted")
  //     } else {
  //       snack.success("General Event Deleted")
  //     }
  //     setOpen(false);
  //     queryClient.invalidateQueries("events");
  //   },
  //   onError: (err: any) => {
  //     snack.error(err.response.data.message);
  //   },
  // });

  // const handleDelete = () => {
  //   confirm({
  //     msg: "Are you sure you want to delete this event?",
  //     action: () => {
  //       mutate({
  //         id: data.id,
  //       });
  //     },
  //   });
  // };

  if (!data) return null;

  return (
    <>
      <Dialog fullWidth open={open} onClose={() => setOpen(false)}>
        <Box p={2}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Box display="flex">
              <span
                style={{
                  background: "#0B8043",
                  marginTop: 9,
                  width: 10,
                  height: 10,
                  borderRadius: "50%",
                }}
              ></span>
              <Typography variant="subtitle2" ml={1}>
                {data.task?.name ? "Task Event" : "General Event"}
              </Typography>
            </Box>
            <Box display="flex">
              {from === "calendar" && (
                <>
                  <IconButton onClick={() => setOpen(false)}>
                    <CloseIcon fontSize="small" />
                  </IconButton>
                </>
              )}
            </Box>
          </Box>
          <Divider />
          <Grid container spacing={2} mt={1}>
            {data?.task && (
              <Grid item xs={6}>
                <Typography variant="caption" fontWeight="bold">
                  Task Name:
                </Typography>
                <Typography variant="body1">{data?.task ? data.task?.name : "Na"}</Typography>
              </Grid>
            )}
            {data?.task && (
              <Grid item xs={6}>
                <Typography variant="caption" fontWeight="bold">
                  Task ID:
                </Typography>
                <Typography variant="body1">{data?.task ? data.task?.taskNumber : "Na"}</Typography>
              </Grid>
            )}
            {data.client && (
              <Grid item xs={6}>
                <Typography variant="caption" fontWeight="bold">
                  Client Name:
                </Typography>
                <Typography variant="body1">
                  {data?.client ? data.client?.displayName : "Na"}
                </Typography>
              </Grid>
            )}
            {data.clientGroup && (
              <Grid item xs={6}>
                <Typography variant="caption" fontWeight="bold">
                  Client Group Name:
                </Typography>
                <Typography variant="body1">
                  {data?.clientGroup ? data.clientGroup?.displayName : "Na"}
                </Typography>
              </Grid>
            )}
            <Grid item xs={6}>
              <Typography variant="caption" fontWeight="bold">
                Event Title:
              </Typography>
              <Typography variant="body1">{data?.title ? data?.title : "Na"}</Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography variant="caption" fontWeight="bold">
                Location:
              </Typography>
              <Typography variant="body1">{data?.location ? data.location : "Na"}</Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography variant="caption" fontWeight="bold">
                Date:
              </Typography>
              <Typography variant="body1"> {moment(data.date).format("MMMM DD, YYYY")}</Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography variant="caption" fontWeight="bold">
                Time:
              </Typography>
              {data?.startTime && data?.endTime && (
                <Typography variant="body1" mt={"3px"} sx={{ color: "#182F53" }}>
                  {` ${moment(data.startTime).format("hh:mm a")} -
                  ${moment(data.endTime).format("hh:mm a")}`}
                </Typography>
              )}
            </Grid>

            {!!data?.members?.length && (
              <Grid item xs={12}>
                <Typography variant="caption" component="div" fontWeight="bold">
                  Members:
                </Typography>
                {data?.members?.length ? (
                  <Typography variant="body1">
                    {data?.members?.map((member: any) => member.fullName).join(", ")}
                  </Typography>
                ) : (
                  <Typography variant="body1">Na</Typography>
                )}
              </Grid>
            )}
            {data?.reminder && (
              <Grid item xs={4}>
                <Typography variant="caption" fontWeight="bold">
                  Reminder:
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <AccessAlarmOutlinedIcon fontSize="small" />
                  <Typography variant="body1" sx={{ padding: "5px" }}>
                    {getTitle(data.reminder)}
                  </Typography>
                </Box>
              </Grid>
            )}
            <Grid item xs={12}>
              <Typography variant="caption" fontWeight="bold">
                Notes:
              </Typography>
              <Box
                sx={{ "& h3, & p, & ol, & ul": { margin: 0 } }}
                dangerouslySetInnerHTML={{
                  __html: data?.notes ? data.notes : "NA",
                }}
              ></Box>
            </Grid>
          </Grid>
        </Box>
      </Dialog>
      {/* <EditEvent data={data} open={editOpen} setOpen={setEditOpen} /> */}
    </>
  );
};

export default ViewEvent;
